import { r } from '../../theme/tokens';
import { chartSwatchContainerWidthPx, chartSwatchRadiusPx, chartSwatchSizePx } from './ChartSwatch';
import type { SxProps, Theme } from '@mui/material/styles';

export const getChartTooltipSx = (theme: Theme): SxProps<Theme> => ({
  backgroundColor: 'transparent !important',
  border: '0 !important',
  boxShadow: 'none !important',
  padding: '0 !important',
  '&.MuiChartsTooltip-paper, & .MuiChartsTooltip-paper': {
    backgroundColor: theme.app.colors.surface,
    border: `1px solid ${theme.app.colors.border}`,
    color: theme.app.colors.text,
    borderRadius: r('md'),
    boxShadow: 'none',
    paddingTop: '8px !important',
    paddingBottom: '12px !important',
    paddingLeft: '7px !important',
    paddingRight: '7px !important',
  },
  color: theme.app.colors.text,
  fontSize: theme.typography.subtitle1.fontSize,
  lineHeight: theme.typography.subtitle1.lineHeight,
  fontWeight: theme.typography.fontWeightRegular,
  '& .MuiTypography-root, & .MuiChartsTooltip-cell, & .MuiChartsTooltip-labelCell, & .MuiChartsTooltip-valueCell, & .MuiChartsTooltip-axisValueCell, & caption, & td, & th':
    {
      color: theme.app.colors.text,
      fontSize: theme.typography.subtitle1.fontSize,
      lineHeight: theme.typography.subtitle1.lineHeight,
      fontWeight: theme.typography.fontWeightRegular,
    },
  '& .MuiChartsTooltip-table, & table': {
    borderCollapse: 'separate',
    borderSpacing: 0,
    border: '0 !important',
    width: 'auto !important',
    tableLayout: 'auto',
  },
  '& .MuiChartsTooltip-table caption, & caption': {
    borderBottom: `1px solid ${theme.app.colors.border} !important`,
    paddingTop: '0 !important',
    paddingBottom: '12px !important',
    paddingLeft: '5px !important',
    paddingRight: '5px !important',
    textAlign: 'left',
    lineHeight: 1.05,
  },
  '& .MuiChartsTooltip-table > tbody > tr > th, & .MuiChartsTooltip-table > tbody > tr > td, & tbody > tr > th, & tbody > tr > td':
    {
      border: '0 !important',
      paddingLeft: '6px !important',
      paddingRight: '6px !important',
      paddingTop: '5px !important',
      paddingBottom: '5px !important',
      verticalAlign: 'middle !important',
    },
  '& .MuiChartsTooltip-table > tbody > tr:first-of-type > th, & .MuiChartsTooltip-table > tbody > tr:first-of-type > td, & tbody > tr:first-of-type > th, & tbody > tr:first-of-type > td':
    {
      paddingTop: '12px !important',
    },
  '& .MuiChartsTooltip-table > tbody > tr:last-of-type > th, & .MuiChartsTooltip-table > tbody > tr:last-of-type > td, & tbody > tr:last-of-type > th, & tbody > tr:last-of-type > td':
    {
      paddingBottom: '8px !important',
    },
  '& .MuiChartsTooltip-labelCell': {
    textAlign: 'left !important',
  },
  '& .MuiChartsTooltip-valueCell': {
    textAlign: 'right !important',
    whiteSpace: 'nowrap',
    fontVariantNumeric: 'tabular-nums',
  },
  '& .MuiChartsTooltip-markContainer': {
    width: `${chartSwatchContainerWidthPx}px !important`,
    display: 'inline-flex !important',
    alignItems: 'center !important',
    verticalAlign: 'middle !important',
  },
  '& .MuiChartsTooltip-mark': {
    width: `${chartSwatchSizePx}px !important`,
    height: `${chartSwatchSizePx}px !important`,
    borderRadius: `${chartSwatchRadiusPx}px !important`,
    marginTop: '0 !important',
    marginBottom: '0 !important',
  },
});
